export default "__VITE_ASSET__BHFY19OW__"